function setLocalStorageItem(key, value, ttl) {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getLocalStorageItem(key) {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

function setContentAcrossClass(className, content) {
  var elements = document.getElementsByClassName(className);
  for (var i = 0; i < elements.length; i++) {
    elements[i].innerHTML = content;
  }
}

function setupFAQToggle() {
  var buttons = document.querySelectorAll(".faq-q");

  buttons.forEach(function (button) {
    button.addEventListener("click", function () {
      var answer = this.nextElementSibling;
      if (answer.style.display === "none" || answer.style.display === "") {
        answer.style.display = "block";
      } else {
        answer.style.display = "none";
      }

      var icon = this.parentElement.querySelector("i");
      if (icon.classList.contains("fa-plus")) {
        icon.classList.remove("fa-plus");
        icon.classList.add("fa-minus");
      } else {
        icon.classList.remove("fa-minus");
        icon.classList.add("fa-plus");
      }
    });
  });
}

document.addEventListener("DOMContentLoaded", function () {
  const rush = getLocalStorageItem("rush");
  if(rush == "no"){
    document.getElementById("rush").remove();
  }
  
  setLocalStorageItem("paymentType", "full-price", 30 * 24 * 60 * 60 * 1000);

  let shadeType = getLocalStorageItem("shade-type");
  if (shadeType == null) {
    setLocalStorageItem("shade-type", "shade-bl1", 30 * 24 * 60 * 60 * 1000);
    shadeType = "shade-bl1";
  }
  let teethToCover = getLocalStorageItem("teeth-to-cover");
  if (teethToCover == null) {
    setLocalStorageItem("teeth-to-cover", "both", 30 * 24 * 60 * 60 * 1000);
    teethToCover = "both";
  }

  let slideIndex = 0;
  carousel();

  function carousel(newIndex) {
    if (newIndex !== undefined) {
      slideIndex = newIndex;
    } else {
      slideIndex++;
    }

    let slides = document.getElementsByClassName("carousel-slide");
    let dots = document.getElementsByClassName("dot");
    if (slideIndex >= slides.length) {
      slideIndex = 0;
    }
    for (let i = 0; i < slides.length; i++) {
      slides[i].style.display = "none";
      dots[i].className = dots[i].className.replace(" active-dot", "");
    }
    slides[slideIndex].style.display = "flex";
    dots[slideIndex].className += " active-dot";
  }

  let dots = document.querySelectorAll(".dot");
  for (let i = 0; i < dots.length; i++) {
    dots[i].addEventListener("click", function () {
      carousel(i);
    });
  }

  setupFAQToggle();
  let fullname = getLocalStorageItem("fullname");
  console.log("fullname", fullname);
  if (fullname != null && fullname.length > 0) {
    document.getElementById("welcome").innerHTML =
      fullname.split(" ")[0] +
      ", we can make the perfect set of veneers for you!";
  }

  let price = 0;
  let oldPrice = 0;
  let installement = 0;

  switch (teethToCover) {
    case "bottom":
      document.getElementById("rows").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i>Bottom row';
      price = 589;
      oldPrice = 999;
      installement = 147.25;
      percent = 40;
      break;
    case "top":
      document.getElementById("rows").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i>Top row';
      price = 589;
      oldPrice = 999;
      installement = 147.25;
      percent = 40;
      break;
    case "both":
      document.getElementById("rows").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i>Top & bottom rows';
      price = 799;
      oldPrice = 1998;
      installement = 199.75;
      percent = 60;
      break;
  }

  if(rush == "yes"){
    price +=150;
    oldPrice += 150;
    installement+=37.5;
  }
  
  setContentAcrossClass("full-price", "Pay $" + price + " today");
  setContentAcrossClass("old-price", "$" + oldPrice);
  setContentAcrossClass("new-price", "$" + price);
  setContentAcrossClass(
    "full-price-monthly",
    "Pay $" + installement + " today"
  );
  setContentAcrossClass("installment-price", "$" + installement);
  setContentAcrossClass("percent-off", percent + "% off");

  switch (shadeType) {
    case "shade-bl1":
      document.getElementById("color").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i> BL1 Hollywood White';
      break;
    case "shade-a1":
      document.getElementById("color").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i> A1 Natural White';
      break;
    case "shade-a2":
      document.getElementById("color").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i> A2 Light Ivory';
      break;
    case "shade-a3":
      document.getElementById("color").innerHTML =
        '<i class="fa-sharp fa-solid fa-check"></i> A3 Medium Ivory';
      break;
  }

  let additionalIssues = getLocalStorageItem("additional-issue");
  if (additionalIssues != null) {
    let issues = additionalIssues.split(",");
    if (issues != null && issues.length > 0) {
      let issue = "none";
      for (let i = 0; i < issues.length; i++) {
        issue = issues[i].length > 0 ? issues[i] : issue;
      }

      switch (issue) {
        case "none":
          document.getElementById("issue").remove();
          break;
        case "gapped":
          document.getElementById("issue").innerHTML =
            '<i class="fa-sharp fa-solid fa-check"></i> Specially designed for gapped teeth';
          break;
        case "discolored":
          document.getElementById("issue").innerHTML =
            '<i class="fa-sharp fa-solid fa-check"></i> Specially designed for discolored teeth';
          break;
        case "crowded":
          document.getElementById("issue").innerHTML =
            '<i class="fa-sharp fa-solid fa-check"></i> Specially designed for crowded teeth';
          break;
        case "chipped":
          document.getElementById("issue").innerHTML =
            '<i class="fa-sharp fa-solid fa-check"></i> Specially designed for chipped teeth';
          break;
      }
    }
  } else {
    document.getElementById("issue").remove();
  }

  var installment = document.querySelectorAll(".installment");
  installment.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      console.log("Installment selected");
      setLocalStorageItem("paymentType", "installment", 30 * 24 * 60 * 60 * 1000);

      var allInputs = document.querySelectorAll("input");

      allInputs.forEach(function (input) {
        input.checked = false;
      });

      var paymentOptions = document.querySelectorAll(".installmentRadio");

      paymentOptions.forEach(function (paymentOption) {
        if (
          paymentOption.type === "checkbox" ||
          paymentOption.type === "radio"
        ) {
          paymentOption.checked = true;
        }
      });
    });
  });
  var fullPrice = document.querySelectorAll(".fullPrice");
  fullPrice.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      setLocalStorageItem("paymentType", "full-price", 30 * 24 * 60 * 60 * 1000);
      console.log("Full price selected");

      var paymentOptions = document.querySelectorAll(".fullPriceRadio");

      paymentOptions.forEach(function (paymentOption) {
        if (
          paymentOption.type === "checkbox" ||
          paymentOption.type === "radio"
        ) {
          paymentOption.checked = true;
        }
      });
    });
  });

  var variants = {
    "shade-bl1": {
      both: 44205044433112,
      top: 44205044465880,
      bottom: 44205044498648,
    },
    "shade-a1": {
      both: 44205044531416,
      top: 44205044564184,
      bottom: 44205044596952,
    },
    "shade-a2": {
      both: 44205044629720,
      top: 44205044662488,
      bottom: 44205044695256,
    },
    "shade-a3": {
      both: 44205044728024,
      top: 44205044760792,
      bottom: 44205044793560,
    },
  };

  var checkoutElements = document.querySelectorAll(".checkout-button");

  checkoutElements.forEach(function (element) {
    element.addEventListener("click", function (event) {
      event.preventDefault();
      const paymentType = getLocalStorageItem("paymentType");
      const shadeType = getLocalStorageItem("shade-type");
      const teethToCover = getLocalStorageItem("teeth-to-cover");
      const rush = getLocalStorageItem("rush");
      console.log("Will pay in: ", paymentType);
      let url =
        "https://dintle-aligners.myshopify.com/cart/44205044433112:1,36048191455396:1";
      if (shadeType != null && teethToCover != null) {
        if (shadeType !== "shade-bl1" || teethToCover !== "both") {
          const variantId = variants[shadeType][teethToCover];
          url =
            "https://dintle-aligners.myshopify.com/cart/" +
            variantId +
            ":1,36048191455396:1";
        }
      }
      if(rush == "yes"){
        url += ",44604523053272:1";
      }
      window.location.href = url;
    });
  });
});
